var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlower4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 505 486",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.974 138.025C356.246 149.654 327.827 168.832 305.171 193.903C322.015 164.551 331.382 131.508 332.448 97.6828C332.448 27.0621 253 0.579346 253 0.579346C253 0.579346 173.552 27.0621 173.552 97.6828C174.618 131.508 183.985 164.551 200.829 193.903C178.133 168.961 149.717 149.906 118.026 138.378C50.8482 116.221 1.14893 183.575 1.14893 183.575C1.14893 183.575 1.76685 267.349 68.9448 289.506C101.421 298.886 135.702 300.159 168.785 293.214C137.889 307.038 110.875 328.261 90.131 355.007C48.6413 412.121 97.3696 480.27 97.3696 480.27C97.3696 480.27 176.818 505.517 218.661 448.403C237.8 420.141 249.601 387.558 253 353.595C256.499 387.344 268.296 419.703 287.339 447.785C328.829 504.899 408.63 479.652 408.63 479.652C408.63 479.652 457.359 411.504 415.869 354.389C395.171 327.706 368.259 306.491 337.48 292.596C370.474 299.544 404.67 298.271 437.055 288.888C504.233 267.084 504.851 182.957 504.851 182.957C504.851 182.957 455.152 116.221 387.974 138.025Z",
    fill: "#F0C419"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M332.448 97.6828C332.448 153.032 300.316 210.676 264.829 252.342C259.151 247.205 250.808 246.313 244.172 250.135C231.689 229.956 217.165 211.113 200.829 193.903C202.33 193.903 173.552 151.443 173.552 97.6828C173.552 27.0621 253 0.579346 253 0.579346C253 0.579346 332.448 27.0621 332.448 97.6828Z",
    fill: "#B0BE0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M332.448 97.6828C332.448 153.032 300.316 210.676 264.829 252.342C259.151 247.205 250.808 246.313 244.172 250.135C231.689 229.956 217.165 211.113 200.829 193.903C202.33 193.903 173.552 151.443 173.552 97.6828C173.552 27.0621 253 0.579346 253 0.579346C253 0.579346 332.448 27.0621 332.448 97.6828Z",
    fill: "url(#paint0_linear_1692_139475)",
    fillOpacity: 0.48
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253 256.579C248.125 256.579 244.172 252.627 244.172 247.752V141.821C244.172 136.945 248.125 132.993 253 132.993C257.875 132.993 261.828 136.945 261.828 141.821V247.752C261.828 252.627 257.875 256.579 253 256.579Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.345 269.115C212.332 274.641 189.964 282.571 168.608 292.772C135.467 299.668 101.148 298.426 68.5918 289.153C1.41383 267.349 0.795898 183.222 0.795898 183.222C0.795898 183.222 50.8483 116.221 118.026 138.025C170.992 155.15 215.13 203.172 244.172 250.135C237.393 253.847 233.816 261.538 235.345 269.115Z",
    fill: "#ECFF15"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.345 269.115C212.332 274.641 189.964 282.571 168.608 292.772C135.467 299.668 101.148 298.426 68.5918 289.153C1.41383 267.349 0.795898 183.222 0.795898 183.222C0.795898 183.222 50.8483 116.221 118.026 138.025C170.992 155.15 215.13 203.172 244.172 250.135C237.393 253.847 233.816 261.538 235.345 269.115Z",
    fill: "url(#paint1_linear_1692_139475)",
    fillOpacity: 0.48
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.228 268.761C234.197 268.761 241.877 271.145 132.768 235.57C128.314 233.929 125.954 229.06 127.427 224.547C128.899 220.035 133.677 217.495 138.241 218.797L238.964 251.548C243.08 252.9 245.606 257.041 244.926 261.32C244.246 265.599 240.56 268.752 236.228 268.761Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253 353.594C249.501 387.344 237.704 419.703 218.661 447.785C177.171 504.899 97.3698 479.652 97.3698 479.652C97.3698 479.652 48.6415 411.503 90.1311 354.389C122.44 309.898 182.379 282.179 235.345 269.115C236.949 276.593 243.185 282.188 250.793 282.974C249.087 306.527 249.827 330.194 253 353.594Z",
    fill: "#CBDD00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253 353.594C249.501 387.344 237.704 419.703 218.661 447.785C177.171 504.899 97.3698 479.652 97.3698 479.652C97.3698 479.652 48.6415 411.503 90.1311 354.389C122.44 309.898 182.379 282.179 235.345 269.115C236.949 276.593 243.185 282.188 250.793 282.974C249.087 306.527 249.827 330.194 253 353.594Z",
    fill: "url(#paint2_linear_1692_139475)",
    fillOpacity: 0.48
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.349 374.251C177.085 374.13 174.154 372.217 172.73 369.277C171.306 366.337 171.622 362.851 173.552 360.215L235.345 274.499C237.332 272.039 240.48 270.826 243.604 271.317C246.728 271.808 249.353 273.928 250.489 276.878C251.626 279.829 251.103 283.162 249.116 285.622L187.323 370.632C185.693 372.863 183.112 374.203 180.349 374.251Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M408.63 479.653C408.63 479.653 329.182 504.899 287.339 447.785C254.677 402.853 246.997 337.528 251.146 282.974C258.651 283.624 265.741 279.44 268.801 272.557C290.744 281.607 313.548 288.409 336.862 292.861C367.72 306.747 394.72 327.959 415.516 354.654C457.359 411.504 408.63 479.653 408.63 479.653Z",
    fill: "#ECFF15"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M408.63 479.653C408.63 479.653 329.182 504.899 287.339 447.785C254.677 402.853 246.997 337.528 251.146 282.974C258.651 283.624 265.741 279.44 268.801 272.557C290.744 281.607 313.548 288.409 336.862 292.861C367.72 306.747 394.72 327.959 415.516 354.654C457.359 411.504 408.63 479.653 408.63 479.653Z",
    fill: "url(#paint3_linear_1692_139475)",
    fillOpacity: 0.48
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M325.651 374.251C322.826 374.259 320.168 372.913 318.501 370.632L256.178 284.916C254.317 282.33 253.977 278.948 255.287 276.043C256.596 273.139 259.355 271.153 262.525 270.835C265.695 270.516 268.794 271.913 270.655 274.499L332.448 360.215C334.378 362.851 334.694 366.337 333.27 369.277C331.846 372.217 328.915 374.131 325.651 374.251Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M504.851 183.575C504.851 183.575 504.233 267.349 437.055 289.506C384.09 307.161 320.178 294.008 269.331 272.91C272.398 265.944 270.654 257.797 265.006 252.695C280.379 234.53 293.839 214.829 305.171 193.903C327.867 168.961 356.283 149.906 387.974 138.378C455.152 116.221 504.851 183.575 504.851 183.575Z",
    fill: "#CBDD00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M504.851 183.575C504.851 183.575 504.233 267.349 437.055 289.506C384.09 307.161 320.178 294.008 269.331 272.91C272.398 265.944 270.654 257.797 265.006 252.695C280.379 234.53 293.839 214.829 305.171 193.903C327.867 168.961 356.283 149.906 387.974 138.378C455.152 116.221 504.851 183.575 504.851 183.575Z",
    fill: "url(#paint4_linear_1692_139475)",
    fillOpacity: 0.48
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M269.772 268.761C265.44 268.752 261.754 265.599 261.074 261.32C260.394 257.041 262.92 252.9 267.036 251.548L367.759 218.797C372.323 217.495 377.101 220.035 378.573 224.547C380.046 229.06 377.686 233.929 373.232 235.57C264.034 271.145 271.891 268.761 269.772 268.761Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280 264.971C280.013 278.077 270.613 289.299 257.708 291.584C244.803 293.869 232.121 286.555 227.635 274.242C223.148 261.928 228.153 248.17 239.503 241.617C247.852 236.797 258.137 236.794 266.489 241.61C274.84 246.426 279.99 255.33 280 264.971Z",
    fill: "#F1FF54"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1692_139475",
    x1: 299.714,
    y1: 0.293296,
    x2: 221.917,
    y2: 242.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1692_139475",
    x1: 244,
    y1: 215.869,
    x2: 19.128,
    y2: 279.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1692_139475",
    x1: 216,
    y1: 268.869,
    x2: 163.199,
    y2: 485.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1692_139475",
    x1: 394.912,
    y1: 272.316,
    x2: 344.382,
    y2: 485.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1692_139475",
    x1: 504.681,
    y1: 216.281,
    x2: 282.528,
    y2: 278.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower4);
export default __webpack_public_path__ + "static/media/flower4.7790481641705348a93498568aee1d22.svg";
export { ForwardRef as ReactComponent };